export default "__VITE_ASSET__Crn7sltd__"